import { ReactNode } from 'react'

import { CustomerFeature } from '@forto-dev/customer-master-data-models'

import { useAuth } from '../api/useAuth'
import { customerHasFeature } from '../domain/customer'
import { UserRole } from '../domain/role'
import { hasRoles } from '../service/roles'

interface AccessProps {
  roles: UserRole[]
  feature?: CustomerFeature
  children: ReactNode
}

export function Access({ roles, feature, children }: AccessProps) {
  const { user, customer, isReady, isCustomerActive } = useAuth()

  if (!isCustomerActive || !isReady || !user || (feature && !customer)) {
    return null
  }

  const hasRequiredRoles = hasRoles(user, roles)

  // Check if customer has required feature (if feature check is needed)
  const hasRequiredFeature = !feature || (customer && customerHasFeature(customer, feature))

  const hasAccess = Boolean(hasRequiredRoles && hasRequiredFeature)

  return hasAccess ? children : null
}
